import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import {
  getFromLocalStorage,
  StorageKey,
  setOnLocalStorage,
  removeFromLocalStorage,
} from '../helpers/localstorage';
import { useAppDispatch, useAppSelector } from '../redux/core';
import { setCurrentOrderId } from '../redux/general/general.actions';
import { currentOrderIdSelector } from '../redux/general/general.selectors';
import { Routes } from '../routes/types';
import { useQueryParams } from './useQueryParams';

export const useOrderId = (avoidRedirect?: boolean) => {
  const history = useHistory();
  const dispatch = useAppDispatch();
  const queryParams = useQueryParams();
  const orderIdFromQp = queryParams.get('id');
  const filter = queryParams.get('filter');
  const orderIdFromStore = useAppSelector(currentOrderIdSelector);

  useEffect(() => {
    const savedOrderId = getFromLocalStorage(StorageKey.OrderId);

    if (!avoidRedirect) {
      if (filter === 'noassign') {
        removeFromLocalStorage(StorageKey.OrderId)
      } else if (
        orderIdFromQp === null &&
        orderIdFromStore === null &&
        savedOrderId === undefined
      ) {
        history.push(Routes.Orders);
      } else if (orderIdFromQp) {
        setOnLocalStorage(orderIdFromQp, StorageKey.OrderId);
        dispatch(setCurrentOrderId(`${orderIdFromQp}`));
      } else if (savedOrderId) {
        dispatch(setCurrentOrderId(`${savedOrderId}`));
      }
    }
  }, [dispatch, history, orderIdFromQp, orderIdFromStore, avoidRedirect, filter]);

  return orderIdFromQp || orderIdFromStore;
};
